<div
  class="reverse-calc-table position-relative"
  *ngIf="{
    rows: rows$ | async,
    tableColumns: props.tableColumns | castObservable | async
  } as tmplData"
>
  <div
    *ngIf="props.description"
    class="mb-2"
    [innerHtml]="props.description"
  ></div>
  <span *ngIf="props.label" class="bold" [innerHtml]="props.label"></span>

  <div class="table w-100 break-inside-avoid">
    <div *ngIf="tmplData.tableColumns" class="reverse-calc-table__header">
      <div class="reverse-calc-table__row d-none d-md-flex bold">
        <div class="reverse-calc-table__key">
          {{ tmplData.tableColumns[0] }}
        </div>
        <div class="reverse-calc-table__value d-flex">
          <ng-container
            *ngFor="let column of tmplData.tableColumns; let first = first"
          >
            <div *ngIf="!first">
              {{ column }}
            </div>
          </ng-container>
        </div>
        <div *ngIf="props.summary" class="reverse-calc-table__row-total">
          {{ props.summary.label }}
        </div>
      </div>
    </div>

    <div>
      <ng-container *ngFor="let row of tmplData.rows; let index = index">
        <div class="reverse-calc-table__row d-md-flex">
          <div class="reverse-calc-table__key">
            <div class="bold text-break-line" [innerHTML]="row.label"></div>
          </div>
          <div class="reverse-calc-table__value d-flex">
            <div
              *ngIf="tmplData.tableColumns"
              class="reverse-calc-table__mobile-labels d-flex flex-column d-md-none"
            >
              <ng-container
                *ngFor="let label of tmplData.tableColumns; let index = index"
              >
                <div
                  *ngIf="index"
                  class="calc-table__mobile-label flex-1 pe-1 py-1"
                >
                  {{ label }}
                </div>
              </ng-container>
            </div>
            <formly-form
              class="w-100"
              [form]="$any(internalForm.at(index))"
              [fields]="row.fields"
              [model]="internalModel"
              (modelChange)="onModelChange()"
            ></formly-form>
          </div>
          <div
            class="reverse-calc-table__row-total hstack bold"
            *ngIf="props.summary"
          >
            <span class="me-1 d-md-none"> {{ props.summary.label }}: </span>
            <span *ngIf="props.summary.addonLeft">{{
              props.summary.addonLeft
            }}</span
            ><span>{{
              (internalForm.at(index).valueChanges
                | async
                | total : internalForm.at(index).value) || 0
                | number : props.summary.decimalFormat || '1.2'
            }}</span
            ><span *ngIf="props.summary.addonRight">{{
              props.summary.addonRight
            }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
